import { type QueryClient } from "@tanstack/react-query";

import { deviceTypeQueryKeys } from "@/shared/domain/deviceTypes/hooks/deviceTypeQueryKeys";

import { type Device } from "../Device";

import { deviceQueryKeys } from "./deviceQueryKeys";
import { getQueryKey as getAllDevicesByOrgKey } from "./useAllDevicesByOrg";

/**
 * Refreshes what lists `devices` after they were deleted or given another
 * type: each of their orgs' device listings (the grid and the all-devices
 * roster behind device pickers), and every device type query, since a type's
 * device count changed.
 */
export function invalidateDeviceListings(
  queryClient: QueryClient,
  devices: readonly Device[],
): void {
  for (const orgId of new Set(devices.map((device) => device.org_id))) {
    void queryClient.invalidateQueries({
      queryKey: deviceQueryKeys.lists(orgId),
    });
    void queryClient.invalidateQueries({
      queryKey: getAllDevicesByOrgKey(orgId),
    });
  }
  void queryClient.invalidateQueries({
    queryKey: deviceTypeQueryKeys.all(),
  });
}
